import { Select } from 'antd'
import React from 'react'
import { useParams } from 'react-router'
import {
    useFetchEligibleFlagAssigneesQuery,
    useUpdateQuestionAnswerEscalatedMutation,
} from '../../../../../../store/apis/submission.api'
import { useVersionId } from '../../../../../../utils/parseURL.helper'
import User from '../../../../../../components/common/user/User'

const AssigneeSelect = ({ escalatedSubmission, currentAssigneeId }) => {
    const { token } = useParams()
    const versionId = useVersionId()

    const { data: eligibleAssignees, isFetching: isFetchingAssignees } =
        useFetchEligibleFlagAssigneesQuery({ token })

    const [updateQuestionAnswerEscalated, { isLoading: isUpdating }] =
        useUpdateQuestionAnswerEscalatedMutation()

    const handleAssigneeChange = async newAssigneeId => {
        await updateQuestionAnswerEscalated({
            id: escalatedSubmission.id,
            escalated: escalatedSubmission.status,
            reviewerId: newAssigneeId,
            submissionId: escalatedSubmission.submissionId,
            questionId: escalatedSubmission.questionId,
            questionRubricId: escalatedSubmission.questionRubricId,
            versionId,
            token,
        })
    }

    const options = eligibleAssignees?.map(assignee => ({
        value: assignee.id,
        label: assignee.name,
        name: assignee.name,
    }))

    const renderOption = option => (
        <User id={option.data.value} name={option.data.name} size="small" />
    )

    const renderLabel = ({ label, value }) => (
        <User id={value} name={label} size="small" />
    )

    return (
        <Select
            value={currentAssigneeId}
            options={options}
            onChange={handleAssigneeChange}
            loading={isFetchingAssignees || isUpdating}
            style={{ minWidth: 140 }}
            popupMatchSelectWidth={false}
            getPopupContainer={triggerNode => triggerNode.parentNode}
            optionFilterProp="label"
            optionRender={renderOption}
            labelRender={renderLabel}
            placeholder="Unassigned"
            allowClear={false}
            variant="borderless"
        />
    )
}

export default AssigneeSelect
